import { render, staticRenderFns } from "./hqStuHealthUser.vue?vue&type=template&id=01e960be&scoped=true"
import script from "./hqStuHealthUser.vue?vue&type=script&lang=js"
export * from "./hqStuHealthUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e960be",
  null
  
)

export default component.exports